/* eslint-disable linebreak-style */
// ----------------------------------------------------------------------------
// Component: Manuals List
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// Styles
import './_manuals-list.scss';

// -------------------------------------
// Dependencies
// -------------------------------------

class iamManualsList extends HTMLElement {
    
    constructor() {
        super();

        this.manualsListItems = this.querySelector('.manuals-list__items');

        this.querySelectorAll('.filter-link').forEach((link) => {
            const filterType = link.dataset.filterType;

            link.addEventListener('click', () => this.onFilterLinkClick(link, filterType));
        });
    }

    onFilterLinkClick(clickedlink, filterType) {

        if (!clickedlink.classList.contains('selected')) {

            this.querySelectorAll('.filter-link').forEach((link) => {
                link.classList.remove('selected');
            });
            clickedlink.classList.add('selected');
            
            const manual_cards = this.manualsListItems.querySelectorAll('.card--manual');
            manual_cards.forEach((card) => {
                const productType = card.dataset.productType;
    
                if (productType == filterType || filterType == 'All') {
                    card.style.display = 'inline-block';
                } else {
                    card.style.display = 'none';
                }
            });
        }
    }
}

customElements.define('iam-manuals-list', iamManualsList);